import { envConstants } from "../constant";

export function getAppHostUrl(): string {
  const subdomain = envConstants.K8S_ENV_PREFIX === "prod" ? "www" : envConstants.K8S_ENV_PREFIX;
  return `https://${subdomain}.directv.com`;
}

export default getAppHostUrl;
